import { render, staticRenderFns } from "./RevisionMutationGroupV1.vue?vue&type=template&id=4b9ad858&"
import script from "./RevisionMutationGroupV1.vue?vue&type=script&lang=js&"
export * from "./RevisionMutationGroupV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports